import { MutationOptions } from '@tanstack/react-query';

import {
  getSignedLogoUploadUrlForUser,
  getSignedMediaUploadUrlForUseCase,
  postCreateSPOptimizerMessageExperimentFromFlowMessage,
  postCreateSPOptimizerStoreFromFlowMessage,
  postCreateSPOptimizermessageFromFlowMessage,
  postDidUploadLogoForUser,
  postDidUploadUseCaseMedia,
  postRenderEmailTemplate,
  postSaveVideoScripts,
  updateUseCaseOnboardingState,
} from './methods';

type QueryMapOption<T> = T extends (...args: infer A) => infer R
  ? MutationOptions<Awaited<R>, unknown, A>
  : never;

export const mutations = {
  signedLogoUploadUrlForUser: (): QueryMapOption<typeof getSignedLogoUploadUrlForUser> => ({
    mutationFn: (args) => getSignedLogoUploadUrlForUser(...args),
  }),
  signedMediaUploadUrlForUseCase: (): QueryMapOption<typeof getSignedMediaUploadUrlForUseCase> => ({
    mutationFn: (args) => getSignedMediaUploadUrlForUseCase(...args),
  }),
  didUploadUseCaseMedia: (): QueryMapOption<typeof postDidUploadUseCaseMedia> => ({
    mutationFn: (args) => {
      return postDidUploadUseCaseMedia(...args);
    },
    onSuccess: (data) => {
      return data;
    },
  }),
  didUploadLogoForUser: (): QueryMapOption<typeof postDidUploadLogoForUser> => ({
    mutationFn: (args) => postDidUploadLogoForUser(...args),
  }),
  useCaseOnboardingState: (): QueryMapOption<typeof updateUseCaseOnboardingState> => ({
    mutationFn: (args) => updateUseCaseOnboardingState(...args),
  }),
  saveVideoScript: (): QueryMapOption<typeof postSaveVideoScripts> => ({
    mutationFn: (args) => postSaveVideoScripts(...args),
  }),
  createSPOptimizerStoreFromFlowMessage: (): QueryMapOption<
    typeof postCreateSPOptimizerStoreFromFlowMessage
  > => ({
    mutationFn: (args) => postCreateSPOptimizerStoreFromFlowMessage(...args),
  }),
  createSPOptimizerMessageFromFlowMessage: (): QueryMapOption<
    typeof postCreateSPOptimizermessageFromFlowMessage
  > => ({
    mutationFn: (args) => postCreateSPOptimizermessageFromFlowMessage(...args),
  }),
  renderEmailTemplate: (): QueryMapOption<typeof postRenderEmailTemplate> => ({
    mutationFn: (args) => postRenderEmailTemplate(...args),
  }),
  createSPOptimizerMessageExperimentFromFlowMessage: (): QueryMapOption<
    typeof postCreateSPOptimizerMessageExperimentFromFlowMessage
  > => ({
    mutationFn: (args) => postCreateSPOptimizerMessageExperimentFromFlowMessage(...args),
  }),
};
